<template>
<div class="row text-center d-flex justify-content-center">
    <div class="col-lg-8 col-lg-offset-2">
        <form id="contact-form">
            <div class="controls">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="form_me">M.Ε. *</label>
                            <input id="form_me" type="text" name="me" v-model="user.monadaLek" class="form-control" disabled=true>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="form_efsa">Α.Σ.Μ *</label>
                            <input id="form_efsa" type="text" name="efsa" v-model="user.efsa" class="form-control" disabled=true>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="form_name">Όνομα *</label>
                            <input id="form_name" type="text" name="name" v-model="user.onoma" class="form-control2">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="form_lastname">Επίθετο *</label>
                            <input id="form_lastname" type="text" name="surname" v-model="user.epitheto" class="form-control2">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="form_email">Email *</label>
                            <input id="form_email" type="text" name="email" class="form-control2" v-model="user.email" placeholder="Εισάγετε το email σας *">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="form_phone">Τηλέφωνο *</label>
                            <input id="form_phone" type="text" name="phone" class="form-control2" v-model="user.thl" placeholder="Παρακαλώ εισάγετε το τηλέφωνο επικοινωνίας">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="form_subject">Θέμα *</label>
                            <input id="form_subject" type="text" name="subject" class="form-control2" v-model="subject" placeholder="Παρακαλώ εισάγετε το θέμα του μηνύματός σας">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="form_message">Μήνυμα *</label>
                            <textarea id="form_message" name="message" class="form-control2" v-model="message" placeholder="Εισαγωγή μηνύματος *" rows="4"></textarea>
                        </div>
                    </div>
                </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label for="form_file">Αρχεία</label>
                                <b-form-file
                                    ref="attachmentInput"
                                    id="form_file"
                                    v-model="files"
                                    :state="this.filesValidity"
                                    placeholder="Κάντε click εδώ για επιλογή αρχείων (Για την επιλογή πολλών αρχείων στον διάλογο κρατήστε πατημένο το πλήκτρο Ctrl και επιλέξτε με click)"
                                    multiple
                                    accept=".pdf"
                                    drop-placeholder="Αφήστε το αρχείο εδώ."
                                ></b-form-file>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="this.files && this.files.length && this.files.length>0">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <button class="btn btn-warning" @click="this.filesReset">Καθαρισμός αρχείων</button>
                            </div>
                        </div>
                    </div>
                    <br>
                <div class="row">
                    <div class="col-md-12" style="text-align: inherit;color: red;">                        
                        <b>Σημαντικό</b>: <span style="color:black;">Στην επισύναψη αρχείων, τα αρχεία που θα επιλέξετε θα πρέπει να είναι τύπου .pdf, δεν πρέπει να είναι περισσότερα από 5 σε πλήθος και το συνολικό μέγεθος <b>(όλων των αρχείων)</b> προς αποστολή, δεν θα πρέπει να υπερβαίνει τα 5 MB.</span>
                        <br><br>
                       <b> * Τα πεδία με αστερίσκο είναι υποχρεωτικά.</b>
                        <br>
                    </div>
                    <div class="col-md-12" style="text-align: center;">
                        <button type="submit" name="submitbtn" id="submitbtn" v-on:click.prevent="submitcontact" class="btn btn-outline-primary">Αποστολή Μηνύματος</button>
                    </div>
                </div>

                <br>

                <div v-if="show_all" class="alert alert-warning alert-dismissible fade show" role="alert">
                    Θα πρέπει να συμπληρώσετε όλα τα στοιχεία προτού προχωρήσετε σε υποβολή.
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div v-if="show_error" class="alert alert-danger alert-dismissible fade show" role="alert">
                    Υπήρξε πρόβλημα με την αποστολή του μηνύματός σας. Παρακαλούμε δοκιμάστε εκ νέου.
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div v-if="show_ok" class="alert alert-success alert-dismissible fade show" role="alert">
                    Η φόρμα επικοινωνίας έχει υποβληθεί επιτυχώς.
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div v-if="flag_special" class="alert alert-danger alert-dismissible fade show" role="alert">
                    Απαγορεύονται οι ειδικοί χαρακτήρες. Παρακαλούμε δοκιμάστε εκ νέου.
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

            </div>
        </form>
    </div>
</div>
</template>

<script>
    import {HTTP} from "../main.js";
    export default {
        name: "ContactME",

        created() {
            this.user = this.$store.getters.user;

            if (this.$store.getters.userRole !== "ROLE_USER") this.$router.push('home');
        },

        data: function() {

            return {
                show_all: false,
                show_error: false,
                show_ok: false,
                flag_special: false,
                user: {
                    onoma: '',
                    epitheto: '',
                    email: '',
                    thl: '',
                },
                subject: '',
                message: '',
                filesValidity: null,
                files: [],
            };
        },

        methods: {
            filesReset: function() {

                this.filesValidity=null;
                this.files = [];
            },
            uploadFilesValidity: function(append = false) {

                if(this.files && this.files.length && this.files.length > 0) {//user selected file(s)

                    if(this.files.length > 5) {

                        this.$bvToast.toast(`Στην επισύναψη αρχείων τα αρχεία που θα επιλέξετε θα πρέπει να είναι τύπου ".pdf", δεν πρέπει να είναι περισσότερα από 5 σε πλήθος και το συνολικό μέγεθος (όλων των αρχείων) δεν πρέπει να υπερβαίνει τα 5 MB.`, {
                                title: 'Αδύνατη αποστολή μηνύματος',
                                autoHideDelay: 5000,
                                variant: 'danger',
                                appendToast: append
                        });

                        return false;
                    } else {

                        let totalSize = 0;
                        let check = true;

                        this.files.forEach(file => {

                            if(file.type!='application/pdf')
                                check = false;

                            totalSize += file.size;
                        });

                        if(check && totalSize / 1000000 <= 5) {

                            this.filesValidity=null;
                            return true;
                        } else {

                            this.filesValidity=false;

                            this.$bvToast.toast(`Στην επισύναψη αρχείων τα αρχεία που θα επιλέξετε θα πρέπει να είναι τύπου ".pdf", δεν πρέπει να είναι περισσότερα από 5 σε πλήθος και το συνολικό μέγεθος (όλων των αρχείων) δεν πρέπει να υπερβαίνει τα 5 MB.`, {
                                title: 'Αδύνατη αποστολή μηνύματος',
                                autoHideDelay: 5000,
                                variant: 'danger',
                                appendToast: append
                            });

                            return false;
                        }
                    }
                } else {//no files selected

                    this.filesValidity=null;
                    this.files = [];
                    return true;
                }                
            },
            readFileAsync: function(file) {
                return new Promise((resolve, reject) => {
                    let reader = new FileReader();

                    reader.onload = () => {
                        resolve(reader.result);
                    };

                    reader.onerror = reject;

                    reader.readAsArrayBuffer(file);
                });
            },
            toBase64: function(text) {

                var binary = '';
                var bytes = new Uint8Array( text );
                var len = bytes.byteLength;

                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode( bytes[ i ] );
                }

                return window.btoa(binary);

            },
            submitcontact: function () {
                
                let fileData = undefined;
                let fileType = undefined;
                let attachmentsCheck = this.uploadFilesValidity();
                
                if(attachmentsCheck == false)
                    return;

                let readFilesPromArr = [];
                
                if(this.files && this.files.length > 0) {
                    
                    this.files.forEach(file => {

                        readFilesPromArr.push(new Promise ((resolve, reject) => {
                           this.readFileAsync(file).then((content) => {

                               resolve({
                                   name: file.name,
                                   type: file.type,
                                   data: this.toBase64(content)
                               });
                           }).catch(err => {
                               reject(err);
                           })
                        }));
                    });
                }

                let attachments = undefined;
                
                Promise.all(readFilesPromArr).then(filesArray => {

                    attachments = filesArray;
                }).catch(err => {
                }).finally(()=> {

                    this.flag_special = false;
                    this.show_all = false;
                    this.show_error = false;
                    this.show_ok = false;

                    let isValidName = this.$validator.onlyLetters(this.user.onoma);
                    let isValidSurname = this.$validator.onlyLetters(this.user.epitheto);
                    let isValidPhone = this.$validator.onlyNumbers(this.user.thl);
                    let isValidEmail = this.$validator.validateEmail(this.user.email);

                    if(!isValidName || !isValidSurname || !isValidPhone || !isValidEmail){
                        this.flag_special = true;
                        this.show_all = false;
                        this.show_ok = false;
                        this.show_error = false;
                        return;
                    }

                    let isEmptyName = this.$validator.isEmpty(this.user.onoma);
                    let isEmptySurname = this.$validator.isEmpty(this.user.epitheto);
                    let isEmptyPhone = this.$validator.isEmpty(this.user.thl);
                    let isEmptyEmail = this.$validator.isEmpty(this.user.email);
                    let isEmptySubject = this.$validator.isEmpty(this.subject);
                    let isEmptyMessage = this.$validator.isEmpty(this.message);
                    let anyFormFieldEmpty = isEmptyName || isEmptySurname || isEmptyPhone || isEmptyEmail || isEmptySubject || isEmptyMessage; 

                    if (anyFormFieldEmpty) {
                        this.show_all = true;
                        this.flag_special = false;
                        this.show_ok = false;
                        this.show_error = false;
                    }
                    
                    if (!this.flag_special)
                    {
                        if (!this.show_all)
                        {
                            let body = {
                                'efsa' : this.$validator.stripTags(this.user.efsa),
                                'name' : this.$validator.stripTags(this.user.onoma),
                                'surname' : this.$validator.stripTags(this.user.epitheto),
                                'email' : this.$validator.stripTags(this.user.email),
                                'phone' : this.$validator.stripTags(this.user.thl),
                                'subject' : this.$validator.stripTags(this.subject),
                                'message' : this.$validator.stripTags(this.message)
                            };
                            
                            if(attachments)
                                body["files"] = attachments;

                            const headers = {
                                'Content-Type': 'application/json',
                            };

                            var url = "/users/contact";

                            this.$store.dispatch('loading');                           
                            HTTP.post(url, body, {
                                headers: headers
                            }).then(response => {

                                var resp = response.data;

                                if (resp.responseData)
                                {
                                    //disable button
                                    document.getElementById('submitbtn').setAttribute("disabled", null);

                                    //show success alert
                                    this.show_ok = true;

                                    this.show_error = false;
                                    this.show_all = false;
                                    this.flag_special = false;
                                }
                                else
                                {
                                    this.show_error = true;

                                    this.show_ok = false;
                                    this.show_all = false;
                                    this.flag_special = false;
                                }
                            }).catch((error) => {
                                console.error(error);

                                this.show_error = true;

                                this.show_ok = false;
                                this.show_all = false;
                                this.flag_special = false;
                            })
                            .finally(() => this.$store.dispatch('stop_loading'));
                        }
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .form-control2 {
        display: block;
        width: 100%;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        border: 1px solid #ced4da;
        border-radius: 0;
        -webkit-transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    }
</style>